import React from 'react';

const Download = ({ height = '12px', width = '12px', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" {...rest}>
    <path d="M20.77,29.007l9,10l0,0C30.319,39.616,31.115,40,32,40s1.68-0.384,2.23-0.993l0,0l9-10l0,0 C43.708,28.475,44,27.772,44,27c0-1.657-1.343-3-3-3c-0.885,0-1.682,0.383-2.23,0.993l0,0L35,29.182V11c0-1.657-1.343-3-3-3 s-3,1.343-3,3v18.182l-3.77-4.189l0,0C24.681,24.384,23.885,24,23,24c-1.657,0-3,1.343-3,3C20,27.772,20.292,28.475,20.77,29.007 L20.77,29.007z M55,35c-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h22.997 c0.001,0,0.002,0,0.003,0s0.002,0,0.003,0H55c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z" />
  </svg>
);

export default Download;
